
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getAntManageList, getSystemNotice, getSystemNoticeList } from '@/api/antManage/antManage'
import { parseTime } from '@/utils'

@Component({
  name: 'sendMes',
  components: {
  },
  filters: {
    parseTime(date) {
      return parseTime(date, '{y}-{m}-{d} {h}:{i}:{s}')
    }
  }
})
export default class extends Vue {
  @Prop({ required: true }) private antName!: any
  @Prop({ required: true }) private antdName!: any
  private loading: boolean = false
  private btnLoading: boolean = false

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private list: any[] = []
  private total = 0
  // private date: any[] = getCurrentDate()
  // private pickerOptions = pickerOptions

  // 分页器设置
  private pagesize: number = 10
  private handleSizeChange (size) {
    this.pagesize = size
    this.init()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.init()
  }

  private sendMessage: any = ''
  // 获取Telegram商户群组
  private async init () {
    try {
      this.loading = true
      let params:any = {
        ant_account: this.antName,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getSystemNoticeList(params).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.loading = false
      })
    } catch (e) {
      console.log()
    }
  }

  private queryForm:any = {
    msg: ''
  }

  private back () {
    this.queryForm = {
      msg: ''
    }
    this.$emit('close')
  }

  private async editorSave () {
    try {
      // this.editAttach()
      this.btnLoading = true
      this.flag = true
      let data: any = {
        ...this.queryForm,
        ant_account: this.antName
      }
      await getSystemNotice(data).then(() => {
        this.$message({
          message: 'Operation is successful!',
          type: 'success'
        })
        this.btnLoading = false
        this.flagStr()
        this.back()
      })
    } catch (e) {
      this.btnLoading = false
      this.flagStr()
    }
  }

  // created () {
  //   this.getTelegroupList()
  // }
}
